export default class AutoRefreshStrategy {
  /**
     * @constructor
     * @param {import("../GeomodImageLayer").default|import("../GeomodTileLayer").default} layer The layer to add auto refresh behavior.
     * @param {number} rate The refresh rate en second.
     */
  constructor(layer, rate) {
    assertPositive(rate);

    /**
         * The layer to refresh.
         */
    this.layer_ = layer;

    /**
         * The refresh rate.
         */
    this.rate_ = rate;

    /**
         * The current listeners.
         * @type {Array<import("ol/events").EventsKey>}
         */
    this.listeners_ = null;
  }

  /**
     * Get the refresh rate.
     * @return {number}
     */
  get rate() {
    return this.rate_;
  }

  /**
     * Set the refresh rate. If autorefresh is running, it restarts the autorefesh.
     */
  set rate(rate) {
    assertPositive(rate);
    this.rate_ = rate;
    // Restart if autorefresh is running.
    if (this.listeners_) {
      this.stop();
      this.start();
    }
  }

  /**
     * Start the auto refresh for the layer.
     */
  start() {
    // Not start if is running.
    if (!this.listeners_) {
      const layer = this.layer_;
      this.startTimer_(layer);

      const prerenderListener = layer.on('prerender', () => this.stopTimer_());
      const postrenderListener = layer.on('postrender', () => this.startTimer_(layer));
      this.listeners_ = [prerenderListener, postrenderListener];
    }
  }

  /**
     * Stop the auto refresh for the layer.
     */
  stop() {
    // Not stop if is not running.
    if (this.listeners_) {
      for (const listener of this.listeners_) {
        this.layer_.un(listener.type, listener.listener);
      }
      this.listeners_ = null;
      this.stopTimer_();
    }
  }

  /**
     * Start timer that will restart the layer.
     * @param {import("../GeomodImageLayer").default|import("../GeomodTileLayer").default} layer The layer to refresh.
     */
  startTimer_(layer) {
    this.timer_ = setTimeout(() => layer.refresh.call(layer), this.rate * 1000);
  }

  /**
     * Stop timer which suppose to refresh the layer.
     */
  stopTimer_() {
    if (this.timer_) {
      clearTimeout(this.timer_);
      delete this.timer_;
    }
  }
}

/**
 * Assert number un positive strictly.
 * @param {number} number The number to check.
 */
function assertPositive(number) {
  if (number <= 0) {
    throw new Error('Number must be positive.');
  }
}
